import { useAppStore } from '../store/appStore';

export const useIsSelfServicedPilot = () => {
  const { pilot } = useAppStore();

  if (pilot === undefined) {
    return null;
  }

  return !pilot?.id;
};
